import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
export function limitNumber(number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : "".concat(number);
}
//# sourceMappingURL=helpers.js.map